import { Box, Button, Typography } from '@mui/material';
import palette from '../../../../shared/lib/theme/palette';
import { useAppContext } from '../../app/contexts/AppContext';
import { ActionType } from '../../app/reducer/AppContextReducer';
import { DeActiveAccountModal } from './DeactiveAccountModal';
import { LABEL_DEACTIVATE_ACCOUNT, NOTE_DEACTIVATE_ACCOUNT } from '../../../../shared/lib/constants';

export const DeActiveAccount = () => {
  const { blackOne, blackTwo } = palette;
  const { isOpen, dispatch } = useAppContext();

  const handleOpen = () => {
    dispatch({ type: ActionType.SET_IS_OPEN, isOpen: !isOpen });
  };

  return (
    <Box>
      <Typography variant="caption" sx={{ fontWeight: '700', color: blackOne, pb: '16px' }}>
        {LABEL_DEACTIVATE_ACCOUNT}
      </Typography>

      <Typography variant="body2" sx={{ fontWeight: '600', color: blackTwo, pb: '16px' }}>
        {NOTE_DEACTIVATE_ACCOUNT}
      </Typography>

      <Button variant="contained" onClick={handleOpen} color="error">
        {LABEL_DEACTIVATE_ACCOUNT}
      </Button>

      <DeActiveAccountModal />
    </Box>
  );
};
